import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import RoundedGainfulButton from "Root/profile/components/common/RoundedGainfulButton";
import Logo from "Images/quiz/logo_square.svg";
import styles from "./styles.module.scss";
import { useHistory } from "react-router";
const TargetNavBar = ({ noButton = false }) => {
    const history = useHistory();
    const getStarted = () => {
        history.push("/quiz-start-target/");
    };
    return (_jsx("div", { className: styles.navbar, children: _jsxs("div", { className: [styles.navbar_wrapper, noButton ? styles.navbar_wrapper_no_button : ""].join(" "), children: [_jsx("img", { src: Logo, alt: "logo" }), !noButton && _jsx(RoundedGainfulButton, { extraClassName: styles.btn, label: "Get Started", onClick: getStarted })] }) }));
};
export default TargetNavBar;
